// import api from "@/service/api";

/**
 * K-line data processing
 */
class DataFeeds {
  /**
   * @param {*Object} store
   */
  constructor(store, pair, apiInterval, pricescaleVal) {
    this.store = store;
    this.pair = pair;
    this.apiInterval = apiInterval;
    this.pricescaleVal = pricescaleVal;
  }

  /**
   * @param {*Function} callback
   * `onReady` should return result asynchronously.
   */
  onReady(callback) {
    console.log("chart onReady");
    const defaultConfiguration = {
      symbols_type: [],
      supported_resolutions: [
        "1",
        "5",
        "15",
        "30",
        "60",
        "240",
        "720",
        "1D",
        "1M",
        "1W",
      ],
      supports_marks: true,
      supports_timescale_marks: false,
      supports_time: false,
    };
    setTimeout(() => {
      console.log("callback-onReady");
      callback(defaultConfiguration);
    });
  }

  /**
   * @param {*Object} symbolInfo  product information object
   * @param {*String} resolution  Resolution
   * @param {*Number} rangeStartDate  Timestamp, leftmost requested K-line time
   * @param {*Number} rangeEndDate  Timestamp, rightmost requested K-line time
   * @param {*Function} onDataCallback  Callback
   * @param {*Function} onErrorCallback  Callback
   */
  async getBars(
    symbolInfo,
    resolution,
    rangeStartDate,
    rangeEndDate,
    onDataCallback
    // onErrorCallback
  ) {
    console.log("getBars", rangeStartDate, rangeEndDate);

    let noData = false;

    const callback = () => {
      // console.log(this.store.data);
      const dataInRange = this.store.data.length
        ? this.store.data.filter(
            (ele) =>
              rangeStartDate * 1000 <= ele.time &&
              ele.time <= rangeEndDate * 1000
          )
        : [];

      noData = !dataInRange.length;

      const bar = [...dataInRange];

      onDataCallback(bar, {
        noData,
      });
    };

    /**
     * Determine whether the time of the first data is greater than the start point of the time interval
     * If it is greater than , continue to get historical records
     */
    const checkStartData = async () => {
      if (
        !this.store.getKLineNoData &&
        rangeStartDate * 1000 < this.store.data[0].time
      ) {
        await getLine();
      }
    };

    /**
     * Get historical K-line data
     */
    const getLine = async () => {
      await this.store.getKLineFunc(this.store.data[0].time - 1, true);

      checkStartData();
    };

    await checkStartData();

    callback();
  }

  /**
   * Subscribe to K-line data. The chart library will call the onRealtimeCallback method to update the real-time data
   * @param {*Object} symbolInfo Product information
   * @param {*String} resolution Resolution
   * @param {*Function} onRealtimeCallback Callback
   * @param {*String} subscriberUID The unique identifier of the listener
   * @param {*Function} onResetCacheNeededCallback (since 1.7): will be executed when the bars data changes
   */
  subscribeBars(symbolInfo, resolution, onRealTimeCallback) {
    console.log("chart subscribeBars");
    this.store.onRealTimeCallback = onRealTimeCallback;
  }

  /**
   * Unsubscribe from K-line data
   * @param {*String} subscriberUID The unique identifier of the listener
   */
  unsubscribeBars() {
    console.log("chart unsubscribeBars");
  }

  /**
   * @param {*String} symbolName  product name or ticker
   * @param {*Function} onSymbolResolvedCallback success callback
   * @param {*Function} onResolveErrorCallback   failure callback
   * `resolveSymbol` should return result asynchronously.
   */
  resolveSymbol(symbolName, onSymbolResolvedCallback) {
    console.log("chart resolveSymbol");
    const newSymbol = Object.assign(
      {},
      {
        timezone: "Asia/Shanghai",
        minmov: 1,
        minmov2: 0,
        pointvalue: 1,
        session: "24x7",
        has_seconds: false,
        has_daily: true,
        has_weekly_and_monthly: true,
        has_no_volume: false,
        has_empty_bars: true,
        description: "",
        has_intraday: true,
        supported_resolutions: [
          "1",
          "5",
          "15",
          "30",
          "60",
          "120",
          "240",
          "360",
          "720",
          "1D",
          "1W",
          "1M",
        ],
        pricescale: 100000000, //price accuracy
        volume_precision: 3, //Quantitative precision
      },
      {
        symbol: symbolName,
        ticker: symbolName,
        name: symbolName,
        pricescale: Math.pow(10, this.pricescaleVal) || this.pricescaleVal, //todo
        volume_precision: 3 || 3,
      }
    );

    setTimeout(() => {
      console.log("onSymbolResolvedCallback");
      onSymbolResolvedCallback(newSymbol);
    });
  }
}

export default DataFeeds;
